import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import notify from '../../CustomHooks/UseNotification'

const CartCheckout = ({ AllCartItems, handleApplyCouponFunc, onChangeCouponName, couponName, CouponNameText, priceAfterDiscount,TotalPrice }) => {
    const navigate = useNavigate()

    const handlecheckOutLink = () => {
        if (AllCartItems.products && AllCartItems.products.length >= 1) {
            navigate("/paymentmethod")
        }
        else {
            notify("Please add items to cart", "warn")
        }
    }
    return (
        <div className="h-253px d-flex justify-content-center w-100  shadow align-items-center">
            <Col className="d-flex flex-column mx-3">
                <div className="d-flex">
                    <input
                        value={couponName}
                        onChange={onChangeCouponName}
                        className="fs-16 dark-color form-control rounded-0 d-inline text-center border"
                        placeholder="Dicount code"
                    />
                    <button className="orange-bg btn rounded-0 text-white border-0 shadow-0 d-inline" onClick={handleApplyCouponFunc}>Apply</button>
                </div>
                {AllCartItems && AllCartItems ? (
                    <div className="text-center d-inline w-100 my-3  fw-bold fs-20">
                        {priceAfterDiscount ? <>  <del>price before Discount {TotalPrice} EGP</del> <p className='mb-0'>price after discount {priceAfterDiscount} EGP</p></> : <p className='mb-0'>price before Discount {TotalPrice} EGP</p>}
                    </div>) : null}
                <button className="orange-bg btn text-white  w-100 py-2 rounded-0" onClick={handlecheckOutLink}> CheckOut </button>

            </Col>
            <ToastContainer/>
        </div>
    )
}

export default CartCheckout
